export const MESSAGES_VALIDATION_RULES = {
  message: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/messages/messagesValidationRules.js